import { Component, Input, OnInit } from '@angular/core';
import { EIconPath } from '../../../../shared/enums/icons.enum';
import { TPushNotification } from '../../notification.model';
import { getNotificationReasonText } from '../../utils/notification-reason';

@Component({
    selector: 'pp-notification-tags',
    templateUrl: './notification-tags.component.html',
    styleUrls: ['../notification.component.scss'],
    standalone: false
})
export class NotificationTagsComponent implements OnInit {
  @Input() ppNotification: TPushNotification<string[]>;

  notificationReason: string;
  EIconPath = EIconPath;

  ngOnInit(): void {
    this.notificationReason = getNotificationReasonText(this.ppNotification.notificationReason);
  }
}
